const SearchInput = {
    props: {
        title: {
            default: "",
            type: String,
        },

        type: {
            default: "text",
            type: String,
        },

        name: {
            default: "",
            type: String,
        },

        placeholder: {
            default: "",
            type: String,
        },

        initialValue: {
            default() {
                return {
                    text: null,
                    id: null,
                    icon: null,
                    selected: false,
                };
            },
            type: Object,
        },

        optionsList: {
            default() {
                return [];
            },
            type: Array,
        },

        searchInputId: {
            default: "",
            type: String,
        },

        required: {
            default: false,
            type: Boolean,
        },
    },

    data() {
        return {
            input_value: null,

            option_icon: null,
            option_text: null,
            option_id: null,
            option_selected: false,

            options: [],

            show_options: false,
            show_options_loading: false,
            show_no_options: false,

            error_message: null,

            valid: false,

            should_validate: false,
        };
    },

    watch: {
        initialValue: {
            handler() {
                if(this.initialValue.text !== this.option_text) {
                    this.selectOption(this.initialValue);
                }
            },
            deep: true,
        },
    },

    mounted() {
        if (this.initialValue.text) {
            this.selectOption(this.initialValue, false);
        }

        this.setEventListeners();
    },

    beforeDestroy() {
        document.removeEventListener("click", this.hideOptions);
    },

    methods: {
        setEventListeners() {
            document.addEventListener("click", (e) => {
                const target = e.target;
                if (this.searchInputId) {
                    const optionsElem = target.closest(`#${this.searchInputId}`);
                    if (!optionsElem) {
                        this.hideOptions();
                    }
                }
            });
        },

        handleInput() {
            this.should_validate = true;
            this.show_options_loading = true;
            this.show_no_options = false;
            this.clearOption();
            this.$emit("clear_option");
            this.openOptions();

            this.options = this.optionsList.filter((option) => {
                return option.text.toLowerCase().includes(this.input_value.toLowerCase());
            });

            if (!this.options.length) {
                this.show_no_options = true;
            }

            this.validate();
            this.setValidationClasses();

            this.show_options_loading = false;

            this.option_text = this.input_value

            this.$emit("selected_option", {
                icon: this.option_icon,
                text: this.option_text,
                id: this.option_id,
                selected: this.option_selected,
            });
        },

        clearOption() {
            this.option_icon = null;
            this.option_id = null;
            this.option_selected = false;
        },

        selectOption(option, should_validate = true) {
            this.should_validate = should_validate;
            this.option_icon = option.icon;
            this.option_text = option.text;
            this.option_id = option.id;
            this.option_selected = true;

            this.input_value = this.option_text;

            this.hideOptions();
            this.validate();
            this.setValidationClasses();

            this.$emit("selected_option", {
                icon: this.option_icon,
                text: this.option_text,
                id: this.option_id,
                selected: this.option_selected,
            });
        },

        openOptions() {
            this.show_options = true;
        },

        hideOptions() {
            this.show_options = false;
        },

        setValidationClasses() {
            if (this.loading) {
                return;
            }

            const el = this.$refs["node"];
            const input = this.$refs["input"];

            if (el && input) {
                if (this.error_message) {
                    el.classList.remove("valid");
                    el.classList.add("invalid");

                    input.classList.remove("valid");
                    input.classList.add("invalid");
                    return;
                }

                if (this.valid) {
                    el.classList.remove("invalid");
                    el.classList.add("valid");

                    input.classList.remove("invalid");
                    input.classList.add("valid");
                    return;
                }

                el.classList.remove("invalid");
                el.classList.remove("valid");

                input.classList.remove("invalid");
                input.classList.remove("valid");
            }
        },

        validate() {
            if(!this.should_validate) {
                return;
            }
            
            // if (this.required && !this.option_selected) {
            //     this.setError();
            //     return;
            // }

            // if (!this.required && this.input_value && !this.option_selected) {
            //     this.setError();
            //     return;
            // }

            if (!this.required && !this.input_value) {
                this.setError();
                return;
            }

            this.error_message = null;
            this.valid = true;
            this.$emit("valid");
        },

        setError() {
            this.error_message = "Выберете значение из списка";
            this.valid = false;
        },

        hasValidationErrors() {
            this.should_validate = true;
            this.validate();
            this.setValidationClasses();

            if (this.valid) {
                return false;
            }

            return true;
        },
    },

    template: /*html*/ `
    <div class="search show" ref="node" :id="searchInputId">
        <div class="search-field">
            <input :type="type" :placeholder="placeholder" v-model="input_value" ref="input" @input="handleInput" class="search-local">
            <div class="append-icon">
                <svg class="icon icon-search-field-icon">
                    <use :xlink:href="this.$bitrix.Application.instance.php_vars.images_folder_path + '/icons/sprite.svg#search-field-icon'"></use>
                </svg>
            </div>
        </div>
        <div class="input-errors" v-html="this.error_message"></div>
        <div class="search-options" v-if="show_options">
            <div class="search-options__list">
                <a class="search-options__item--no-select" v-if="show_options_loading">
                    <div class="search-options__item-text">Идет поиск</div>
                </a>
                <a class="search-options__item--no-select" v-if="show_no_options">
                    <div class="search-options__item-text">Список пуст</div>
                </a>
                <a class="search-options__item" v-if="!show_no_options && !show_options_loading" v-for="option in options" :key="option.id" @click.prevent="selectOption(option)">
                    <div class="search-options__item-logo"><img :src="option.icon" alt=""></div>
                    <div class="search-options__item-text">{{option.text}}</div>
                </a>
            </div>
        </div>
    </div>
  `,
};

export default SearchInput;
